import { render, staticRenderFns } from "./StudentTCSPByItemBarChartHorizontal.vue?vue&type=template&id=a1eabdd2&"
import script from "./StudentTCSPByItemBarChartHorizontal.vue?vue&type=script&lang=js&"
export * from "./StudentTCSPByItemBarChartHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports